import { Component } from '@angular/core';
import { UIButtonsComponent } from '@features/dev/ui-components/buttons/ui-buttons.component';
import { ThemeSwitchComponent } from '@core/components/navbar/theme-switch.component';
import { UITogglesComponent } from '@features/dev/ui-components/toggle/ui-toggles.component';
import { UIBadgesComponent } from '@features/dev/ui-components/badges/ui-badges.component';
import { UIPaginationComponent } from '@features/dev/ui-components/pagination/ui-pagination.component';
import { UIAlertsComponent } from '@features/dev/ui-components/alerts/ui-alerts.component';
import { DialogService } from '@flowkit/dialog';
import { UIDialogsComponent } from '@features/dev/ui-components/dialog/ui-dialogs.component';
import { UIInputsComponent } from '@features/dev/ui-components/inputs/ui-inputs.component';
import { UISelectComponent } from '@features/dev/ui-components/select/ui-select.component';
import { UISearchSelectComponent } from '@features/dev/ui-components/search-select/ui-search-select.component';
import { UIMenuComponent } from '@features/dev/ui-components/menu/ui-menu.component';
import { UITextAreasComponent } from '@features/dev/ui-components/text-area/ui-text-areas.component';

@Component({
  selector: 'app-ui-components',
  providers: [DialogService],
  imports: [
    ThemeSwitchComponent,
    UIButtonsComponent,
    UITogglesComponent,
    UIBadgesComponent,
    UIPaginationComponent,
    UIAlertsComponent,
    UIDialogsComponent,
    UIInputsComponent,
    UISelectComponent,
    UISearchSelectComponent,
    UIMenuComponent,
    UITextAreasComponent,
  ],
  template: `
    <div class="bg--default h-full overflow-y-scroll p-5">
      <div class="text-end">
        <app-theme-switch />
      </div>
      <div class="flex flex-col gap-20">
        <app-ui-buttons />
        <app-ui-badges />
        <app-ui-toggles />
        <app-ui-pagination />
        <app-ui-alerts />
        <app-ui-dialogs />
        <app-ui-inputs />
        <app-ui-text-areas />
        <app-ui-search-select />
        <app-ui-select />
        <app-ui-menu />
      </div>
    </div>
  `,
})
export class UIComponentsComponent {}
